import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './../../styles/admin/cuenta.css';
import * as globals from './../../components/GlobalScripts.js';

const Admin_cuenta = () => {
    let path_api = localStorage.getItem('path_api');
    const [formDataAccount, setFormDataAccount] = useState({});

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            let userParsed = JSON.parse(user_cache);

            if (userParsed.account) {
                if (!userParsed.account?.img_profile)
                    userParsed.account.img_profile = userParsed.img_profile;
                setFormDataAccount(userParsed.account);
            }
        }
    }, []);

    const handleSubmit_account = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());
        formData.append('account', JSON.stringify(formDataAccount));

        if (formDataAccount.image) {
            formData.append('image', formDataAccount.image);
        }

        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/account.php`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Cuenta actualizada.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setFormDataAccount(response.data.user.account);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Tu cuenta no se actualizó",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al actualizar la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    const handleChange_account = (e) => {
        const { name, type, checked, value, files } = e.target;
        let newValue;
        if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files[0];
        } else {
            newValue = value;
        }
        setFormDataAccount({ ...formDataAccount, [name]: newValue });
    };

    return (
        <>
            <div className='page-cuenta container-section medium-section flex-column gap-20'>
                <form onSubmit={handleSubmit_account} className="flex-column gap-20">
                    <h3>Cuenta</h3>
                    <div className="form-group">
                        <label htmlFor="image">Para cargar o actualizar foto de perfil da click en la imagen</label>
                        <img
                            src={path_api + formDataAccount?.img_profile}
                            alt="Perfil"
                            onClick={() => document.getElementById('image').click()}
                            className='cursor-pointer'
                        />
                        <input
                            type="file"
                            id="image"
                            name="image"
                            onChange={handleChange_account}
                            className="input-primary"
                            accept="image/*"
                            style={{ display: formDataAccount.image ? 'block' : 'none' }}
                        />
                        {formDataAccount?.image && (
                            <h5 className='text-red'>Cambios aun no guardados.</h5>
                        )}
                    </div>
                    <div className="form-grop-row">
                        <div className="form-group">
                            <label htmlFor="nombre">Nombre(s)</label>
                            <input
                                type="text"
                                id="nombre"
                                name="nombre"
                                value={formDataAccount.nombre}
                                onChange={handleChange_account}
                                className="input-primary"
                                placeholder="nombre"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="apellidos">Apellidos</label>
                            <input
                                type="text"
                                id="apellidos"
                                name="apellidos"
                                value={formDataAccount.apellidos}
                                onChange={handleChange_account}
                                className="input-primary"
                                placeholder="apellidos"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formDataAccount.email}
                            onChange={handleChange_account}
                            className="input-primary"
                            placeholder="ejemplo@ejemplo.com"
                            disabled
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">Telefono</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formDataAccount.phone}
                            onChange={handleChange_account}
                            className="input-primary"
                            placeholder="--- --- ----"
                            required
                        />
                    </div>

                    <div className="buttons-opt">
                        <button className="button-primary" type="submit">
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default Admin_cuenta;
